(function () {
  const checkboxEls = document.querySelectorAll('.product-add__checkbox.complementary');

  if (checkboxEls.length === 0) return;

  function animationTimeline(atrEl, classEl, setAtr, removeAtr, addClasses, removeClasses, timeout) {
    if (timeout >= 0) {
      setTimeout(() => {
        if ((setAtr, atrEl)) {
          atrEl.setAttribute(setAtr, true);
        }

        if (removeClasses.length > 0 && classEl) {
          removeClasses.forEach((removeClass) => {
            classEl.classList.remove(removeClass);
          });
        }

        if (addClasses.length > 0 && classEl) {
          addClasses.forEach((addClass) => {
            classEl.classList.add(addClass);
          });
        }

        if (removeAtr && atrEl) {
          atrEl.removeAttribute(removeAtr);
        }
      }, timeout);
    }
  }

  checkboxEls.forEach((el) => {
    el.addEventListener('change', (e) => {
      const target = e.currentTarget;
      const checkboxLabel = e.currentTarget
        .closest('.product-add__checkbox-wrap')
        ?.querySelector('.product-add__label');

      if (checkboxLabel) {
        if (target.checked) {
          animationTimeline(target, checkboxLabel, 'disabled', null, ['is-start', 'dark-color'], [], 0);
          animationTimeline(null, checkboxLabel, null, null, ['is-loading'], ['is-start'], 500);
          animationTimeline(null, checkboxLabel, null, null, ['is-end'], ['is-loading'], 1500);
          animationTimeline(target, checkboxLabel, null, 'disabled', ['is-added'], ['is-end'], 2000);
        } else {
          animationTimeline(target, checkboxLabel, 'disabled', null, ['is-start'], ['is-added', 'dark-color'], 0);
          animationTimeline(null, checkboxLabel, null, null, ['is-loading'], ['is-start'], 500);
          animationTimeline(null, checkboxLabel, null, null, ['is-reverse-end'], ['is-loading'], 1500);
          animationTimeline(target, checkboxLabel, null, 'disabled', [], ['is-reverse-end'], 2000);
        }
      }
    });
  });
})();
